import * as React from 'react';

function SvgEyeOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M11.984 5.54c-3.479 0-7.048 2.013-9.858 6.04a.714.714 0 00-.012.794c2.16 3.379 5.68 6.022 9.87 6.022 4.145 0 7.739-2.651 9.901-6.038a.721.721 0 000-.78c-2.167-3.348-5.787-6.039-9.9-6.039z" }),
        React.createElement("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.6, d: "M11.999 15.539a3.571 3.571 0 100-7.142 3.571 3.571 0 000 7.142z" })));
}

export default SvgEyeOutline;
